<template>
  <Card>
    <template #title>
      <div class="text-xl">Rate changes</div>
    </template>
    <template #content>
      <DataTable
        :value="rateChanges.changes"
        :loading="rateChanges.loading"
        dataKey="id"
        size="small"
      >
        <Column header="Effective (UTC)">
          <template #body="{ data }">{{
            formatUtc(data.effective_at)
          }}</template>
        </Column>
        <Column header="Change">
          <template #body="{ data }">
            <template v-if="data.old_value != null">
              {{ formatRate(data.old_value) }} →
            </template>
            <template v-else>→</template>
            {{ formatRate(data.new_value) }}
          </template>
        </Column>
        <Column header="Status">
          <template #body="{ data }">
            <Tag :value="statusLabel(data)" :severity="statusSeverity(data)" />
          </template>
        </Column>
        <Column header="Applied (UTC)">
          <template #body="{ data }">{{ formatUtc(data.applied_at) }}</template>
        </Column>
        <Column header="Created (UTC)">
          <template #body="{ data }">{{ formatUtc(data.created_at) }}</template>
        </Column>
        <Column>
          <template #body="{ data }">
            <Button
              v-if="isOpen(data)"
              label="Cancel"
              class="p-button-sm p-button-outlined p-button-warning"
              :loading="rateChanges.saving"
              @click="rateChanges.cancel(data.id)"
            />
          </template>
        </Column>
      </DataTable>
    </template>
  </Card>
</template>

<script setup>
import moment from "moment";
import Card from "primevue/card";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Tag from "primevue/tag";
import Button from "primevue/button";
import { OPEN_RATE_CHANGE_STATUSES } from "@/composables/useSellerRateChanges";

// eslint-disable-next-line no-undef
defineProps({
  // useSellerRateChanges() of this seller
  rateChanges: { type: Object, required: true },
});

const STATUS_SEVERITY = {
  pending: "info",
  retry: "warning",
  applied: "success",
  failed: "danger",
  skipped: "warning",
  cancelled: "secondary",
  overdue: "warning",
};

const isOpen = (change) => OPEN_RATE_CHANGE_STATUSES.includes(change.status);

// Still pending after its time: the lambda has not picked it up yet
const isOverdue = (change) =>
  change.status === "pending" && moment.utc(change.effective_at).isBefore();

const statusLabel = (change) => (isOverdue(change) ? "overdue" : change.status);
const statusSeverity = (change) => STATUS_SEVERITY[statusLabel(change)];

const formatRate = (value) => `$${Number(value)}`;
const formatUtc = (iso) =>
  iso ? moment.utc(iso).format("MMM D, YYYY HH:mm") : "-";
</script>
